import { createEventBus } from "@core/features/eventBus";
import { Invitation } from "@core/features/invitation";

export type AuthEvents = {
  "auth:signup:intent": {
    invitation?: Invitation;
  };
  "auth:signup:started": {
    invitation?: Invitation;
  };
  "auth:signup:completed": { invitation: Invitation };
  "auth:login:intent": void;
};

export const authEventBus = createEventBus<AuthEvents>();
